import React from "react";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import DevelopmentPerformance from "../components/DevelopmentPerformance/DevelopmentPerformance";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import { Helmet } from "react-helmet";
// import {
//   bannerList,
//   facts,
//   faqData,
//   hireGoLangPageContent, // This will now hold all your static content
//   mainBannerImg,
//   servicesData,
//   solutionsData,
//   steps,
//   tabItems,
//   tabs,
//   techCombinations,
// } from "../data/hire-goLang-data-arabic";
import HirePageAppIdea from "../components/hire-page-app-idea/HirePageAppIdea";
import HirePageEngagmentModels from "../components/hire-page-engagment-models/HirePageEngagmentModels";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HirePageExperties from "../components/hirepageExperties/HirePageExperties";
import ContactSection from "../components/contactSection/ContactSection";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import SimpleModels from "../components/simpleEngagementModels";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";
import { hireGoLangEngagementModeContent } from "../data/hire-goLang-data";

const HireGoLang = () => {
  const { t } = useTranslation("hireGoLangPageContent");
  const helmet = t("helmet", { returnObjects: true });
  const mainBanner = t("mainBanner", { returnObjects: true });
  const golangExpertise = t("golangExpertise", { returnObjects: true });
  const whyChooseUs = t("whyChooseUs", { returnObjects: true });
  const techCombinations = t("techCombinations", { returnObjects: true });
  const hireSteps = t("hireSteps", { returnObjects: true });
  const coverTheStack = t("coverTheStack", { returnObjects: true });
  const expertFacts = t("expertFacts", { returnObjects: true });
  const appIdeaSection = t("appIdeaSection", { returnObjects: true });
  const hirePageEngagementModels = t("hirePageEngagementModels", {
    returnObjects: true,
  });
  const faqSection = t("faqSection", { returnObjects: true });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("hireGolangTitle", { returnObjects: false });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });

  return (
    <>
      <Helmet>
        <title>Golang Development Services | Hire Go Developer at Bitsclan</title>
        <meta
          name="description"
          content="Bitsclan offers skilled Golang developers for custom software, APIs, and cloud solutions. Hire dedicated Go experts to build scalable and high-performance applications."
        />
      </Helmet>

      <MegaMenu />

      <HirePageBanner
        diffBannerBackgroundImage={mainBanner?.backgroundImage}
        bgGradientClass="bgGradient-green"
        image={""}
        mainHeading={mainBanner?.mainHeading}
        content={mainBanner?.content}
        btnText={mainBanner?.btnText}
        bannerList={mainBanner?.bannerList}
      />

      <OurServices
        mainHeading={golangExpertise?.heading}
        description={golangExpertise?.description}
        servicesCardsData={golangExpertise?.servicesData}
        buttonText="Schedule a Call Today"
      />

      <DevelopmentPerformance
        buttonText={whyChooseUs.btnText}
        heading={whyChooseUs?.heading}
        greenHeading={whyChooseUs?.greenHeading}
        subHeading={whyChooseUs?.subHeading}
        solutions={whyChooseUs?.solutionsData}
      />

      <HireCombinationSection
        combinations={techCombinations?.combinations}
        heading={techCombinations?.heading}
        description={techCombinations?.description}
      />

      <HirePageSteps
        buttonText={hireSteps.btnText}
        heading={hireSteps?.heading}
        subHeading={hireSteps?.subHeading}
        steps={hireSteps?.steps}
      />

      <CoverTheStack
        whereStart={coverTheStack?.whereStart}
        mainHeading={coverTheStack?.mainHeading}
        subHeading={coverTheStack?.subHeading}
        tabs={coverTheStack?.tabs}
        tabItems={coverTheStack?.tabItems}
      />

      <HireExpertFacts
        buttonText={expertFacts.btnText}
        heading={expertFacts?.heading}
        greenHeading={expertFacts?.greenHeading}
        facts={expertFacts?.facts}
        diffBannerBackgroundImage={expertFacts?.backgroundImage}
      />

      <HirePageAppIdea
        heading={appIdeaSection.heading}
        content={appIdeaSection?.content}
      />

      {/* <HirePageEngagmentModels
        buttonText={hirePageEngagementModels.btnText}
        heading={hirePageEngagementModels?.headingContent}
        content={hirePageEngagementModels?.discription}
        hiringDetails={hirePageEngagementModels.hiringDetails}
      /> */}

      <SimpleModels content={hireGoLangEngagementModeContent} />

      <TrendsInsights specificClass="mobile-dev-page" category="all" />

      <SecondFaq
        specificClass="mobile-dev-page"
        faqs={faqSection?.faqData}
        mainHeading={faqSection?.mainHeading}
        subHeading={faqSection?.subHeading}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default HireGoLang;
